import type { StoreSwitcher } from '@jane/bloom/types/schemas/bloom/storeSwitcher';

/**
 * Defined separately so that the hook can be mocked while allowing
 * you to fill in the rest of the context in tests.
 */
export const defaultStoreSwitcherContext: StoreSwitcher = {
  addressSuggestions: [],
  availableStores: [],
  busy: false,
  deliveryStores: [],
  displayAddressSuggestions: false,
  handleSearchAddressChanged: () => {},
  handleSearchReservationModeChanged: () => {},
  hasPinnedStoreId: false,
  inDeliveryRange: false,
  isUndeliverableAddress: false,
  isVisible: false,
  locationButtonDisabled: false,
  medStores: [],
  pickupStores: [],
  pinnedStore: null,
  pinning: false,
  recStores: [],
  reservationModeWarningShown: false,
  searchAddress: '',
  searchReservationMode: 'pickup',
  selectSuggestedAddress: () => {},
  setAddressSuggestions: () => {},
  setBusy: () => {},
  setLocationButtonDisabled: () => {},
  setPinnedStore: () => {},
  setReservationModeWarningShown: () => {},
  setStoreType: () => {},
  storeType: 'all',
  toggleVisibility: () => {},
  updateShoppingPreferences: () => {},
  validateAddress: () => {},
  validationState: 'idle',
};
